import { useCallback, useEffect, useState } from 'react';

import { BeakerOutline, Box } from '@bonusly/design-system';
import { ProductTier, useCurrentCompany, useCurrentUser, useIdentityStore } from '@bonusly/who-am-i';

export function BonuslyWebTools() {
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const [open, setOpen] = useState(false);

	const available = user?.super_admin || company?.is_demo;
	const isTierOne = company.product_tier === ProductTier.TierOne;

	const toggleProductTier = useCallback(() => {
		const tier = isTierOne ? ProductTier.TierTwo : ProductTier.TierOne;
		useIdentityStore.setState({ company: { ...company, product_tier: tier } });
		setOpen((open) => !open);
	}, [company, isTierOne]);

	useEffect(() => {
		if (!available) return;
		const listener = (ev: globalThis.KeyboardEvent) => {
			if (ev.ctrlKey) setOpen((open) => !open);
		};
		document.addEventListener('keydown', listener);
		document.addEventListener('keyup', listener);
		return () => {
			document.removeEventListener('keydown', listener);
			document.removeEventListener('keyup', listener);
		};
	}, [available]);

	if (!available) return null;

	return (
		<Box
			alignItems="center"
			bgColor={isTierOne ? '#ad9ef3' : '#7b5ce0'}
			borderRadius="100% 0 0 100%"
			boxShadow="md"
			color="white"
			cursor="pointer"
			display="flex"
			h={10}
			justifyContent="center"
			right={open ? -3 : -10}
			onClick={toggleProductTier}
			position="fixed"
			transition="all 0.2s"
			top={3}
			w={10}
			zIndex={Number.MAX_SAFE_INTEGER}
		>
			<BeakerOutline size="sm" />
		</Box>
	);
}
